import { Table, Button, Typography, Chip, Stack } from "@mui/joy";
import { Add, People } from "@mui/icons-material";
import { PageStandard } from "../utils/PageStandard";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaymentQuote, PaymentQuoteStatus } from "../utils/Model";
import { getPaymentQuotes } from "../utils/ViewModel";
import { formatCurrency, formatDateTime } from "../utils/Utils";

const STATUS_LABELS: Record<PaymentQuoteStatus, string> = {
    [PaymentQuoteStatus.bozza]: "Bozza",
    [PaymentQuoteStatus.inviato]: "Inviato",
    [PaymentQuoteStatus.pagato]: "Pagato",
    [PaymentQuoteStatus.fallito]: "Fallito",
    [PaymentQuoteStatus.scaduto]: "Scaduto",
    [PaymentQuoteStatus.annullato]: "Annullato",
    [PaymentQuoteStatus.rimborsato]: "Rimborsato",
};

const STATUS_COLORS: Record<PaymentQuoteStatus, "neutral" | "primary" | "warning" | "success" | "danger"> = {
    [PaymentQuoteStatus.bozza]: "neutral",
    [PaymentQuoteStatus.inviato]: "primary",
    [PaymentQuoteStatus.pagato]: "success",
    [PaymentQuoteStatus.fallito]: "danger",
    [PaymentQuoteStatus.scaduto]: "warning",
    [PaymentQuoteStatus.annullato]: "neutral",
    [PaymentQuoteStatus.rimborsato]: "warning",
};

export function PaymentQuotes() {
    const navigate = useNavigate();
    const [quotes, setQuotes] = useState<PaymentQuote[]>([]);

    useEffect(() => {
        getPaymentQuotes().then(setQuotes).catch(() => setQuotes([]));
    }, []);

    return (
        <PageStandard
            title="Pagamenti"
            sidebarVisible={true}
            headerEnd={
                <Stack direction="row" spacing={1}>
                    <Button size="sm" variant="soft" startDecorator={<People />} onClick={() => navigate("/pagamenti/destinatari")}>
                        Destinatari
                    </Button>
                    <Button size="sm" startDecorator={<Add />} onClick={() => navigate("/pagamenti/nuovo")}>
                        Nuovo preventivo di pagamento
                    </Button>
                </Stack>
            }
        >
            <Table aria-label="Preventivi di pagamento" size="md" stickyHeader>
                <thead>
                    <tr>
                        <th style={{ width: "22%" }}>Cliente</th>
                        <th style={{ width: "18%" }}>Titolo</th>
                        <th style={{ width: "12%" }}>Stato</th>
                        <th style={{ width: "13%" }}>Totale</th>
                        <th style={{ width: "17%" }}>Inviato il</th>
                        <th style={{ width: "18%" }}>Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    {quotes.map((q) => (
                        <tr key={q.id}>
                            <td>
                                <Typography level="title-sm">{q.customer_first_name} {q.customer_last_name}</Typography>
                                <Typography level="body-xs" color="neutral">{q.customer_email}</Typography>
                            </td>
                            <td><Typography level="body-sm">{q.title || "—"}</Typography></td>
                            <td><Chip size="sm" color={STATUS_COLORS[q.status]}>{STATUS_LABELS[q.status]}</Chip></td>
                            <td><Typography level="body-sm">{formatCurrency(q.total_amount)}</Typography></td>
                            <td><Typography level="body-xs" color="neutral">{q.sent_at ? formatDateTime(q.sent_at) : "—"}</Typography></td>
                            <td>
                                <Button size="sm" variant="soft" onClick={() => navigate(`/pagamenti/${q.id}`)}>Gestisci</Button>
                            </td>
                        </tr>
                    ))}
                    {!quotes.length && (
                        <tr>
                            <td colSpan={6}>
                                <Typography level="body-sm" color="neutral" sx={{ py: 2, textAlign: "center" }}>
                                    Nessun preventivo di pagamento ancora creato.
                                </Typography>
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </PageStandard>
    );
}
